import React from "react";
import { useLocation } from "react-router-dom";
import Category from "components/Category";
import { NCRCategoryRow, NCRCategoryListProps } from "./NCRCategoryList.types";
import { useNCRCategoryCategoryProps } from "./NCRCategoryList.hooks";

const NCRCategoryList: React.FC<NCRCategoryListProps> = (props) => {
  const location = useLocation();
  const categoryProps = useNCRCategoryCategoryProps(props, location);

  return (
    <div className="NCRCategoryPage CardListPage">
      <Category<NCRCategoryRow> {...categoryProps} />
    </div>
  );
};

export default NCRCategoryList;
